import React, { useState } from 'react';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { TextArea, Popup, notification, NOTIFICATION_TYPES } from '_atoms';
import { Typography, TYPOGRAPHY_WEIGHT } from '_atoms/Typography';
import { getCandidateInfo, getTimeline, setCandidateRemoveBlacklist } from 'actions';
import { useAppDispatch } from 'store';
import './style.scss';
import type { CandidateData } from 'store/reducers/candidateReducer';

interface PopupRemoveBlacklistProps {
  open: boolean;
  onClose: () => void;
  candidate: CandidateData;
}

export const PopupRemoveBlacklist: React.FC<PopupRemoveBlacklistProps> = ({ open, onClose, candidate }) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const { id } = useParams<{ id: string }>();
  const [comment, setComment] = useState('');
  const onChangeComment = (e: React.ChangeEvent<HTMLTextAreaElement>) => setComment(e.target.value);

  const onClosePopup = () => {
    setComment('');
    onClose();
  };

  const onRemoveBlackList = () => {
    setCandidateRemoveBlacklist(candidate.uuid, { comment }).then(() => {
      notification({ message: 'Candidate has been removed from the blacklist.', type: NOTIFICATION_TYPES.SUCCESS });
      dispatch(getCandidateInfo(id));
      dispatch(getTimeline(id, undefined, true));
      onClose();
    });
  };

  return (
    <Popup
      open={open}
      title={t('translation:popup_remove_blacklist.title')}
      className="candidate-remove-blacklist"
      cancelButtonProps={{
        children: t('translation:popup_remove_blacklist.cancel'),
        onClick: onClosePopup,
      }}
      okButtonProps={{
        children: t('translation:popup_remove_blacklist.confirm'),
        disabled: !comment,
        onClick: onRemoveBlackList,
      }}
    >
      <Typography.Text className="candidate-remove-blacklist__name-latin" weight={TYPOGRAPHY_WEIGHT.BOLD}>
        {candidate.first_name_latin} {candidate.last_name_latin}
      </Typography.Text>
      <Typography.Caption className="candidate-remove-blacklist__name-local">
        {candidate.first_name_local} {candidate.last_name_local}
      </Typography.Caption>
      <Typography.Text className="candidate-remove-blacklist__warning">
        {t('translation:popup_remove_blacklist.warning_text')}
      </Typography.Text>
      <TextArea
        label={t('translation:popup_remove_blacklist.label_comment')}
        value={comment}
        placeholder={t('translation:popup_remove_blacklist.placeholder_comment')}
        onChange={onChangeComment}
        maxLength={6000}
      />
    </Popup>
  );
};
